import React, { Component } from 'react'
import { observer } from 'mobx-react'
import style from './style.module.less'
import ShadowBoxItem from '../../common/ShadowBoxItem'
@observer
export default class extends Component {
  render() {
    const {
      pictureList,
      changeStatus,
      onPictureMove,
      onPictureReplace,
      onPictureDelete,
      onPictureCopy
    } = this.props.store
    return (
      <div className={style.container}>
        {!!pictureList.length && (
          <div className={style.pictureGroup} id="sessionPictureContainer">
            {pictureList.map((el, i) => (
              <ShadowBoxItem
                isSessionPicture
                key={i}
                index={i}
                maxLength={pictureList.length}
                showPath={el.content.media_path}
                showRichText={el.kind == 3}
                {...el}
                {...this.props}
                onClick={() => changeStatus(i)}
                onMoveUp={() => onPictureMove('up', i)}
                onMoveDown={() => onPictureMove('down', i)}
                onPictureReplace={() => onPictureReplace(i)}
                onDelete={() => onPictureDelete(i)}
                onCopy={() => onPictureCopy(i)}
              />
            ))}
          </div>
        )}
      </div>
    )
  }
}
